import { render, staticRenderFns } from "./InventoryPurchaseSupplierGroup.vue?vue&type=template&id=2bb20fd6&"
import script from "./InventoryPurchaseSupplierGroup.vue?vue&type=script&lang=js&"
export * from "./InventoryPurchaseSupplierGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports